import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { Component, Suspense, lazy } from "react";
import MobileRedirect from './MobileRedirect';
import MobileSwitchPopup from './MobileSwitchPopup';
import MainPage from './MainPage';
import PredictionMarketsWave4Page from './highlights/PredictionMarketsWave4Page';
import AIBoomPage from './highlights/AIBoomPage';
import NJICreativePage from './highlights/NJICreativePage';
import SelfDrivingPage from './highlights/SelfDrivingPage';
import IntroPage from './highlights/IntroPage';
import StoryGate from './highlights/StoryGate';
import AppTheme from "../src/shared-theme/AppTheme.js";
import 'mapbox-gl/dist/mapbox-gl.css';
import './App.css';
import SignIn from './SignIn.js';
import ReportRenderPage from './ReportRenderPage';
import { SelectionProvider } from './state/SelectionContext';

import { CssBaseline } from "@mui/material";
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from "../src/theme/customizations";

const MobileApp = lazy(() => import('./mobile/MobileApp'));

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

export default class App extends Component {
  render() {
    return (
    <AppTheme {...this.props} disableCustomTheme={false} themeComponents={xThemeComponents}>
          <CssBaseline />
    <SelectionProvider>
    <Router>
      <MobileRedirect />
      <MobileSwitchPopup />
      <Routes>
        {/* /m must be before any /:slug catch-all — lazy-loaded, no desktop deps */}
        <Route
          path="/m"
          element={
            <Suspense fallback={<div style={{ background: "#e8e8e8", height: "100vh" }} />}>
              <MobileApp />
            </Suspense>
          }
        />
        <Route path="/" element={<SignIn />} />
        <Route path="/pol" element={<MainPage />} />
        <Route path="/environ" element={<MainPage />} />
        <Route path="/healthcare" element={<MainPage />} />
        <Route path="/consumer" element={<MainPage />} />
        <Route path="/phrma" element={<MainPage />} />
        <Route path="/pmi" element={<MainPage />} />
        <Route path="/stateleg" element={<MainPage />} />
        <Route path="/ai" element={<MainPage />} />
        <Route path="/gamble" element={<MainPage />} />
        <Route path="/selfdrive" element={<MainPage />} />
        <Route path="/acc_politics" element={<MainPage />} />
        <Route path="/acc_policy" element={<MainPage />} />
        <Route path="/acc_climate" element={<MainPage />} />
        <Route path="/demo-pol" element={<MainPage />} />
        <Route path="/demo-health" element={<MainPage />} />
        <Route path="/intuit" element={<MainPage />} />
        <Route path="/nji" element={<MainPage />} />
        <Route path="/invariant_message" element={<MainPage />} />
        <Route path="/invariant_industry" element={<MainPage />} />
        <Route path="/invariant_h2h" element={<MainPage />} />
        <Route path="/example_client" element={<MainPage />} />
        <Route path="/report" element={<MainPage />} />
        {/* Standalone report render — mounts a report component WITHOUT MainPage,
            for the headless-Chromium PDF pipeline. Explicit route (no /:slug
            catch-all in this app), so order is not load-bearing. */}
        <Route path="/report-render" element={<ReportRenderPage />} />
        {/* Highlights reels. <StoryGate> applies each story's access setting from
            highlights/stories.js — public stories render straight through with no
            auth request; gated ones send a logged-out visitor to sign in first. */}
        <Route path="/highlights/prediction-markets" element={<StoryGate slug="prediction-markets"><PredictionMarketsWave4Page /></StoryGate>} />
        {/* The wave-aware rebuild. Kept alongside the original rather than
            replacing it: the original is the April-2026 snapshot that has
            already been shown to clients, so its numbers must stay reachable. */}
        {/* The data-centers reel stays pulled: no route and no registry entry,
            so its URLs 404. DataCentersPage.js remains in highlights/ so it can
            be restored by re-adding both. ai-boom is back, ACCESS.GATED, so it
            is signed-in users only and is not listed anywhere. */}
        <Route path="/highlights/ai-boom" element={<StoryGate slug="ai-boom"><AIBoomPage /></StoryGate>} />
        <Route path="/highlights/nji-creative" element={<StoryGate slug="nji-creative"><NJICreativePage /></StoryGate>} />
        <Route path="/highlights/selfdriving" element={<StoryGate slug="selfdriving"><SelfDrivingPage /></StoryGate>} />
        <Route path="/highlights/intro" element={<StoryGate slug="intro"><IntroPage /></StoryGate>} />

      </Routes>
    </Router>
    </SelectionProvider>
    </AppTheme>
    );
  }
}
